import { BLUE } from '../../Theme/palette';
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button, Upload } from 'antd';
import React from 'react';

interface IProps {
  file: { base64: string; name: string; contentType: string } | null;
  onSelect: (file: File) => void;
  onRemove: () => void;
  onPreview?: () => void;
}

export const ItemInvoiceAttachment: React.FC<IProps> = ({ file, onSelect, onRemove, onPreview }) => {
  if (!file) {
    return (
      <Upload.Dragger
        accept="image/*,.pdf"
        showUploadList={false}
        beforeUpload={(f) => {
          onSelect(f);
          return false;
        }}
        style={{ padding: '16px 0' }}
      >
        <p className="ant-upload-drag-icon" style={{ marginBottom: 4 }}>
          <InboxOutlined style={{ fontSize: 28, color: '#13c2c2' }} />
        </p>
        <p className="ant-upload-text" style={{ fontSize: 14, margin: 0 }}>
          {L('Click or drag invoice image to attach')}
        </p>
        <p className="ant-upload-hint" style={{ fontSize: 12, margin: '4px 0 0' }}>
          {L('Supports JPG, PNG, PDF')}
        </p>
      </Upload.Dragger>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0' }}>
      <span
        onClick={onPreview}
        style={{
          flex: 1,
          fontSize: 13,
          color: onPreview ? BLUE.badge : undefined,
          cursor: onPreview ? 'pointer' : 'default',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {file.name}
      </span>
      <Button type="text" danger size="small" icon={<DeleteOutlined />} onClick={onRemove} />
    </div>
  );
};
